import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const createQuotes = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'quotes.can_start_in_portal') &&
  (hasScopedPermission(grants, 'system', 'quotes.create') ||
    hasScopedPermission(grants, 'partner', 'quotes.create') ||
    hasScopedPermission(grants, 'user', 'quotes.create'));
